import { useSignUpOwFApplication } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_hooks/useSignUpOwFApplication";

export const useRetailerOpenWithFaire = () => {
  const openWithFaire = useSignUpOwFApplication();
  return { openWithFaire };
};
